import { io } from "socket.io-client";

const URL =
  process.env.NODE_ENV === "production" ? undefined : "http://localhost:3002";

// export const socket = io("http://localhost:3002");
// export const socket = io("https://demo-chat-api.ajnavidya.com");
export const socket = io("https://chat.ajnavidya.com");

export const notification = io("https://notification.ajnavidya.com");
// export const notification = io("http://localhost:8100");
